import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { logoutUser } from "../../store/auth/login/actions";
import BlurSafeDropdown from "./BlurSafeDropdown";

const ProfileDropdown = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state) => state.Profile.user);
    const isSuperAdmin = useSelector((state) => state.Profile.is_super_admin);

    const displayName = user && (user.name || user.email) ? (user.name || user.email) : "Account";
    const subText = isSuperAdmin
        ? "Super-admin"
        : user && user.role && user.role.name ? user.role.name : "Member";

    const onLogout = (e) => {
        if (e) e.preventDefault();
        dispatch(logoutUser(history));
    };

    return (
        <BlurSafeDropdown
            align="right"
            trigger={(open, toggle) => (
                <button
                    type="button"
                    onClick={toggle}
                    aria-haspopup="menu"
                    aria-expanded={open}
                    aria-label="Account menu"
                    className="bl-profile-trigger"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 10,
                        height: 40,
                        padding: "0 4px 0 4px",
                        paddingRight: 12,
                        borderRadius: 12,
                        background: open
                            ? "rgba(var(--bl-accent-rgb), 0.16)"
                            : "rgba(var(--bl-accent-rgb), 0.08)",
                        border: open
                            ? "1px solid rgba(var(--bl-accent-rgb), 0.5)"
                            : "1px solid var(--bl-line-strong)",
                        color: open ? "#fff" : "var(--bl-text-strong)",
                        cursor: "pointer",
                        transition: "background 160ms ease, border-color 160ms ease, color 160ms ease, box-shadow 200ms ease",
                        boxShadow: open ? "0 0 0 3px rgba(var(--bl-accent-rgb), 0.18)" : "none",
                        fontFamily: "var(--bl-font-body)",
                    }}
                    onMouseEnter={(e) => {
                        if (!open) {
                            e.currentTarget.style.background = "rgba(var(--bl-accent-rgb), 0.14)";
                            e.currentTarget.style.color = "#fff";
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (!open) {
                            e.currentTarget.style.background = "rgba(var(--bl-accent-rgb), 0.08)";
                            e.currentTarget.style.color = "var(--bl-text-strong)";
                        }
                    }}
                >
                    <span style={{
                        width: 32,
                        height: 32,
                        borderRadius: 8,
                        background: "rgba(var(--bl-accent-rgb), 0.18)",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}>
                        <i
                            className="ri-settings-3-line"
                            style={{
                                fontSize: 16,
                                transition: "transform 400ms cubic-bezier(.76,0,.24,1)",
                                transform: open ? "rotate(60deg)" : "rotate(0deg)",
                                color: "#fff",
                            }}
                        />
                    </span>
                    <span
                        className="bl-profile-trigger-text"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            lineHeight: 1.15,
                            minWidth: 0,
                            maxWidth: 180,
                        }}
                    >
                        <span style={{
                            fontSize: 13,
                            fontWeight: 500,
                            color: "inherit",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                        }}>
                            {displayName}
                        </span>
                        <span style={{
                            fontSize: 11,
                            color: "var(--bl-text-soft)",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                        }}>
                            {subText}
                        </span>
                    </span>
                </button>
            )}
        >
            <div style={{
                padding: "0.65rem 0.75rem 0.5rem",
                borderBottom: "1px solid var(--bl-line)",
                marginBottom: 4,
            }}>
                <div style={{
                    fontSize: 10,
                    color: "var(--bl-text-soft)",
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    marginBottom: 2,
                }}>
                    {subText}
                </div>
                <div style={{
                    fontSize: 13,
                    color: "#fff",
                    fontWeight: 500,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}>
                    {displayName}
                </div>
            </div>

            <button className="bl-dropdown-item" onClick={() => history.push("/change-password")}>
                <i className="ri-key-2-line" style={{ marginRight: 10, fontSize: 16, color: "var(--bl-text-soft)" }} />
                Change password
            </button>

            {isSuperAdmin && (
                <button className="bl-dropdown-item" onClick={() => history.push("/users")}>
                    <i className="ri-team-line" style={{ marginRight: 10, fontSize: 16, color: "var(--bl-text-soft)" }} />
                    Manage users
                </button>
            )}

            <div className="bl-dropdown-divider"></div>

            <button
                className="bl-dropdown-item"
                onClick={onLogout}
                style={{ color: "#ff8a98" }}
            >
                <i className="ri-logout-box-r-line" style={{ marginRight: 10, fontSize: 16, color: "#ff8a98" }} />
                Sign out
            </button>
        </BlurSafeDropdown>
    );
};

export default ProfileDropdown;
